import { Observable, switchMap } from 'rxjs';
import { createAuthorizationHeaders, get$, post$, put$ } from 'services/axios';
import {
  BankAccountManageResponse,
  BankAccountCreatePayload,
  BankAccountEntityResponse,
  BankAccountSummaryResponse,
} from 'types/dto';

/**
 * Create an observable emitting account creation response
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createCreateAccount$ =
  (token$: Observable<string>) => (payload: BankAccountCreatePayload) =>
    token$.pipe(
      switchMap(token =>
        post$<void>(`/v1/bank-accounts`, payload, createAuthorizationHeaders(token)),
      ),
    );

/**
 * Create an observable emitting account details
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createGetAccount$ = (token$: Observable<string>) => (id: string) =>
  token$.pipe(
    switchMap(token =>
      get$<BankAccountEntityResponse>(`/v1/bank-accounts/${id}`, createAuthorizationHeaders(token)),
    ),
  );

/**
 * Create an observable emitting account list
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createGetAccountList$ = (token$: Observable<string>) => () =>
  token$.pipe(
    switchMap(token =>
      get$<BankAccountManageResponse>(
        '/v1/bank-accounts/manage',
        createAuthorizationHeaders(token),
      ),
    ),
  );

/**
 * Create an observable emitting account summary
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createGetAccountSummary$ = (token$: Observable<string>) => () =>
  token$.pipe(
    switchMap(token =>
      get$<BankAccountSummaryResponse>(
        '/v1/bank-accounts/summary',
        createAuthorizationHeaders(token),
      ),
    ),
  );

/**
 * Create an observable emitting account update response
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createUpdateAccount$ =
  (token$: Observable<string>) => (id: string, payload: BankAccountCreatePayload) =>
    token$.pipe(
      switchMap(token =>
        put$<void>(`/v1/bank-accounts/${id}`, payload, createAuthorizationHeaders(token)),
      ),
    );
